import React, { useRef } from 'react';
import styles from './css/ClickHere.module.css';

export default function ClickHere(props) {
  const { onClick, className, ...rest } = props;
  const touchFired = useRef(false);
  const navigationAllowed = useRef(false);

  const handleTouchStart = (e) => {
    navigationAllowed.current = false;
    touchFired.current = true;


    // If the handler didn’t stop default navigation,
    // mark navigationAllowed as true
    if (!e.defaultPrevented) navigationAllowed.current = true;
  };

  const handleClick = (e) => {
    if (touchFired.current && !navigationAllowed.current) {
      // stop accidental double-trigger
      e.preventDefault();
      e.stopPropagation();
      touchFired.current = false;
      return;
    }

    onClick?.(e);
    touchFired.current = false;
  };

  return (
    <button
      type="button"
      onTouchStart={handleTouchStart}
      onClick={handleClick}
      className={`${styles.clickHere} ${className || ''}`}
      {...rest}
    >
      [click here]
    </button>
  );
}
